export * from './vca-alert';
export * from './vca-alerts.service';
export * from './vca-alerts';



// WEBPACK FOOTER //
// ./src/common/vca-alerts/index.ts